// import * as XLSX from "xlsx";
import MemberDueCalc from "./MemberDueCalc";
import * as XLSX from "xlsx-js-style";

export const membersExportMethod = (dataForExport) => {
    if (!dataForExport || !Array.isArray(dataForExport) || dataForExport.length === 0) {
        console.warn("No data available for export");
        return;
    }

    // Step 1: Format data
    const membersForExport = dataForExport.map((singleMember, key) => ({
        "SL": key + 1,
        "ID": singleMember.id || "",
        "Grade": singleMember.grade || "",
        "Name": singleMember.member_name || "",
        "Village": singleMember.village || "",
        "Neighborhood": singleMember.neighborhood || "",
        "Police station": singleMember.police_station || "",
        "District": singleMember.district || "",
        "State": singleMember.state || "",
        "Place": singleMember.place || "",
        "City": singleMember.city || "",
        "Collector ID": singleMember?.agent_id,
        "Mobile": singleMember.mobile || "",
        "Whatsapp": singleMember.whats_app || "",


        // "Area type": singleMember.area_type || "",
        // "Post Office": singleMember.post_office || "",
        // "Pincode": singleMember.pincode || "",
        // "Agent name": singleMember.user?.full_name || "",
        // "Agent user name": singleMember.user?.user_name || ""
    }));

    // Step 2: Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(membersForExport);

    // Step 3: Auto column width
    const headers = Object.keys(membersForExport[0]);
    const colWidths = headers.map(header => ({
        // wch: Math.max(header.length, 15)
        wch: header.length + 5
    }));
    ws["!cols"] = colWidths;

    // Step 4: Style header row (row index 0)
    headers.forEach((_, i) => {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
        if (ws[cellAddress]) {
            ws[cellAddress].s = {
                fill: { fgColor: { rgb: "FFFF00" } }, // yellow background
                font: { bold: true, color: { rgb: "000000" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } }
                }
            };
        }
    });

    // Step 5: Append sheet and export file
    XLSX.utils.book_append_sheet(wb, ws, "Members");
    XLSX.writeFile(wb, "all_donor.xlsx");
};